import {Container} from 'react-bootstrap';
import {Row} from 'react-bootstrap';
import {Col} from 'react-bootstrap';
import {Card} from 'react-bootstrap';
import image from './i2.jpg';
import image1 from './i15.jpg';
import image2 from './i20.jpeg';
import image3 from './i33.jpeg';
import image4 from './i35.jpeg';
import image5 from './i37.jpeg';
import image6 from './i20.jpg';
import image7 from './i31.jpeg';
import image8 from './wp4.jpeg';
import gd1 from './c1.png';
import gd2 from './TOKYO.png';
import gd3 from './DRAKE.png';
function Projects(){
    
    // const iconColor = {background:"tomato"};

   return(
   <div className="projects-content pb-5">
        <Container >

            <div className="Projects" id="projects">
                <h2 className="projects-head">My Projects</h2>
                <hr className="projects-line"/>
            </div>

            <Row className="mt-5">
                 <h2>Web Developement</h2>
            </Row>

  <Row className="projects-row mt-5">
      
    <Col>
            <div className="card1">
            <Card style={{ width: '18rem' }} className="card">
  <Card.Body>
    <Card.Title>Covid-19 App</Card.Title>
    <Card.Text>
      Displays the total Covid cases Worldwide & Countrywise.
    </Card.Text>
    <a  href="https://coronavirus-live-tracker.netlify.app/"  variant="dark">Link</a>
  </Card.Body>
</Card>
            </div>
    </Col>



    <Col >
    <div className="card2">
    <Card style={{ width: '18rem' }} className=" card">
  <Card.Body>
    <Card.Title>Todo App</Card.Title>
    <Card.Text>
      Helps users to keep track of their todo list.
    </Card.Text>
    <a href="https://todo-app-vidhur.netlify.app/" variant="dark">Link</a>
  </Card.Body>
</Card>
         
     </div>
    </Col>

    <Col>
    <div className="card3">
    <Card style={{ width: '18rem' }} className="card">
  <Card.Body>
    <Card.Title>Quiz App</Card.Title>
    <Card.Text>
      Users can take quiz and final score will be displayed in the end.
    </Card.Text>
    <a href="https://quiz-app-vidhur.netlify.app/" variant="dark">Link</a>
  </Card.Body>
</Card>
         
     </div>
    </Col>

  </Row>






  <Row className="mt-5">
                 <h2>Photography</h2>
            </Row>

  <Row className="projects-row mt-5">
      
    <Col>
            <div className="card1">
       
    <img  src={image} width="300px" alt=""/>

            </div>
    </Col>



    <Col>
            <div className="card1">
       
    <img  src={image1} width="300px" alt=""/>

            </div>
    </Col>

    <Col>
            <div className="card1">
       
    <img  src={image2} width="300px" alt=""/>

            </div>
    </Col>

  </Row>

  
  <Row className="projects-row mt-5">
      
    <Col>
            <div className="card1">
       
    <img  src={image3} width="300px" alt=""/>

            </div>
    </Col>



    <Col>
            <div className="card1">
       
    <img  src={image4} width="300px" alt=""/>

            </div>
    </Col>

    <Col>
            <div className="card1">
       
    <img  src={image5} width="300px" alt=""/>

            </div>
    </Col>

  </Row>


  <Row className="projects-row mt-5">
      
      <Col>
              <div className="card1">
         
      <img  src={image6} width="300px" alt=""/>
  
              </div>
      </Col>
  
  
  
      <Col>
              <div className="card1">
         
      <img  src={image7} width="300px" alt=""/>
  
              </div>
      </Col>
  
      <Col>
              <div className="card1">
         
      <img  src={image8} width="300px" alt=""/>
  
              </div>
      </Col>
  
    </Row>


    <Row className="mt-5">
                 <h2>Graphic Designing</h2>
            </Row>

  <Row className="projects-row mt-5 mb-5">
      
    <Col>
            <div className="card1">
       
    <img  src={gd1} width="300px" alt=""/>

            </div>
    </Col>



    <Col>
            <div className="card1">
       
    <img  src={gd2} width="300px" alt=""/>

            </div>
    </Col>

    <Col>
            <div className="card1">
       
    <img  src={gd3} width="300px" alt=""/>

            </div>
    </Col>

  </Row>



</Container>
  </div>
);
}

export default Projects;